import { IInboxRecord } from "../../../lib/types";
import React, { useEffect } from "react";
import { TooltipProvider, TooltipTrigger, TooltipContent, Tooltip } from "../../ui/tooltip";
import { Link } from "react-router-dom";
import { format } from "date-fns";
interface props {
    message: IInboxRecord;
    archived?: boolean;
}
export default function InboxListItem({ message, archived = false }: props) {
    return (
        <Link to={`/studio${archived ? "/archive" : ""}/inbox/${message.id}`} className={`flex items-center justify-between rounded-lg bg-slate-100 p-6 dark:bg-slate-800 ${message.read && "opacity-80"} transition-transform hover:scale-105`}>
            <div className="flex flex-col items-center gap-2">
                <span className="w-full font-bold">'{message.subject}'</span>
                <span className="w-full text-sm italic opacity-60">from {message.email}</span>
                <span className="w-full text-xs italic opacity-50">{format(new Date(message.created), "d/M/y - H:m")}</span>
            </div>
            <span className="flex items-center">
                {message.read ? (
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 text-emerald-500">
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                            </TooltipTrigger>
                            <TooltipContent>Message read</TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                ) : (
                    <TooltipProvider>
                        <Tooltip>
                            <TooltipTrigger>
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="h-5 w-5 text-blue-500">
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M10.34 15.84c-.688-.06-1.386-.09-2.09-.09H7.5a4.5 4.5 0 110-9h.75c.704 0 1.402-.03 2.09-.09m0 9.18c.253.962.584 1.892.985 2.783.247.55.06 1.21-.463 1.511l-.657.38c-.551.318-1.26.117-1.527-.461a20.845 20.845 0 01-1.44-4.282m3.102.069a18.03 18.03 0 01-.59-4.59c0-1.586.205-3.124.59-4.59m0 9.18a23.848 23.848 0 018.835 2.535M10.34 6.66a23.847 23.847 0 008.835-2.535m0 0A23.74 23.74 0 0018.795 3m.38 1.125a23.91 23.91 0 011.014 5.395m-1.014 8.855c-.118.38-.245.754-.38 1.125m.38-1.125a23.91 23.91 0 001.014-5.395m0-3.46c.495.413.811 1.035.811 1.73 0 .695-.316 1.317-.811 1.73m0-3.46a24.347 24.347 0 010 3.46"
                                    />
                                </svg>
                            </TooltipTrigger>
                            <TooltipContent>Message not yet read</TooltipContent>
                        </Tooltip>
                    </TooltipProvider>
                )}
            </span>
        </Link>
    );
}
